import { arrayOf, bool, shape, string } from 'prop-types'

export const footerLinkType = shape({
  text: string.isRequired,
  href: string.isRequired,
  renderAsButton: bool,
})

export const footerLinksType = shape({
  help: arrayOf(footerLinkType).isRequired,
  company: arrayOf(footerLinkType).isRequired,
  legal: arrayOf(footerLinkType).isRequired,
})
